<template>
  <div>{{ dialTime }}</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CallingTimer',
  computed: {
    ...mapGetters('call', ['dialTime'])
  }
}
</script>
